var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.59955 7.68778H4.04041V9.24693H5.59955V7.68778ZM8.71784 7.68778H7.1587V9.24693H8.71784V7.68778ZM11.8361 7.68778H10.277V9.24693H11.8361V7.68778ZM13.3953 2.23078H12.6157V0.671631H11.0566V2.23078H4.81998V0.671631H3.26084V2.23078H2.48126C1.61594 2.23078 0.929915 2.93239 0.929915 3.78992L0.922119 14.7039C0.922119 15.5615 1.61594 16.2631 2.48126 16.2631H13.3953C14.2528 16.2631 14.9544 15.5615 14.9544 14.7039V3.78992C14.9544 2.93239 14.2528 2.23078 13.3953 2.23078ZM13.3953 14.7039H2.48126V6.12864H13.3953V14.7039Z",
    fill: "#A8ADB2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.4127c4e9103a2a7152a9c2c102cb2fa2.svg";
export { ForwardRef as ReactComponent };